<script>
import LoansTable from '@/views/loans/Table';

export default {
    components: {
        LoansTable
    },

    extends: LoansTable,

    props: {
        loanProductId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            includeHeader: false
        };
    },

    computed: {
        additionalFetchData() {
            return {
                status: this.activeTab.value,
                loanProductId: this.loanProductId
            };
        }
    }
};
</script>
